<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  contactName: {
    type: String,
    default: '',
  },
  contactId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['disableDnd']);

const { t } = useI18n();
const isDisabling = ref(false);

const handleDisableDnd = () => {
  isDisabling.value = true;
  emit('disableDnd', props.contactId);
};
</script>

<template>
  <div
    class="flex items-center justify-between px-4 py-3 bg-n-red-2 border-b border-n-red-6"
  >
    <div class="flex items-center gap-2">
      <span class="text-n-red-11 text-xl">⚠️</span>
      <div class="flex flex-col">
        <span class="text-sm font-medium text-n-red-12">
          {{ $t('DND.WARNING.TITLE') }}
        </span>
        <span class="text-xs text-n-red-11">
          {{
            $t('DND.WARNING.MESSAGE', { name: contactName || 'This contact' })
          }}
        </span>
      </div>
    </div>
    <button
      class="text-sm font-medium text-n-red-11 hover:text-n-red-12 underline disabled:opacity-50"
      :disabled="isDisabling"
      @click="handleDisableDnd"
    >
      {{ isDisabling ? 'Disabling...' : $t('DND.WARNING.CONFIRM') }}
    </button>
  </div>
</template>
